import { z } from 'zod';

import { EscrowDueId, EscrowSettingId, LosId, PropertyId } from '../../BrandedIds';
import { EscrowInsuranceType, EscrowSettingStatus, TaxEscrowType } from '../../loan/EscrowSetting';
import { zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';
import { NonNegativeMonetaryValue } from '../../validations/fields';

export const ExportableEscrowDue = z
  .object({
    id: zodBrandedUuid<EscrowDueId>(),
    loanId: zodBrandedString<LosId>(),

    propertyId: zodBrandedUuid<PropertyId>(),
    escrowSettingId: zodBrandedUuid<EscrowSettingId>(),
    dueDate: zodTemporalPlainDate,
    estimatedAmount: NonNegativeMonetaryValue,
    amountPaid: NonNegativeMonetaryValue,
    escrowed: z.boolean(),
    fulfilled: z.boolean(),
    status: EscrowSettingStatus,
    type: z.enum(['tax', 'insurance', 'mortgageInsurance']),
    taxType: TaxEscrowType.optional(),
    insuranceName: z.string().optional(),
    insuranceType: EscrowInsuranceType.optional(),
  })
  .meta({ title: 'EscrowDue' });

export type ExportableEscrowDue = z.infer<typeof ExportableEscrowDue>;
